const alerts = {
  configuringData: 'Please wait, we are configuring your data',
  configuringError: 'An error occurred during setup, please try again.',
  configuringFailed:
    'We\'re sorry, an error occurred while configuring your data. Please try again later, if the problem persists contact the administrator',
  configuringSuccess: 'Configuration successful',
  errorOccurred: 'Sorry, an error occurred',
  noCode: 'No code',
  noMessage: 'No message',
  notAvailable: 'Not available',
  pageNotFound: '404 - Page not found',
  pleaseWait: 'Please wait',
  savedData: 'Saved data',
  triggeredAnError:
    'Something happened in setting up the request that triggered an error',
  unansweredRequest: 'The request was made but no response was received',
};

export default alerts;
